var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      .text { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; }\n    ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mainGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0F2C59",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#153d7a",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 L140,0 C190,0 220,30 220,80 C220,130 190,160 140,160 L110,160 L110,240 L50,240 Z M110,110 L140,110 C155,110 160,105 160,80 C160,55 155,50 140,50 L110,50 Z",
    fill: "url(#mainGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,240 L270,80 L320,240 L295,240 L285,200 L255,200 L245,240 Z M270,140 L260,170 L280,170 Z",
    fill: "url(#mainGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,240 L360,80 L410,240 L385,240 L375,200 L345,200 L335,240 Z M360,140 L350,170 L370,170 Z",
    fill: "url(#mainGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,270 Q 230,340 420,250",
    fill: "none",
    stroke: "#DAC0A3",
    strokeWidth: 20,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCustom);
export default __webpack_public_path__ + "static/media/logo_custom.67d611631aa9f4dd49ec59a89bc8b9b5.svg";
export { ForwardRef as ReactComponent };